import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default class HeaderAnimations {
	constructor() {
		this.mainHeader = document.querySelector('#header');
		this.logoV = document.querySelector('.logo-svg');

		if (!this.mainHeader) return;

		this.tl = gsap.timeline({
			defaults: {
				opacity: 0,
				ease: 'back',
			},
		});
		window.addEventListener('load', () => {
			this._init();
			this._pinLogoV();
			// this._heroScrollTrigger();
		});
	}
	_init() {

		// this.tl.from(
		// 	this.mainHeader.querySelector('.company__logo .company__logo__v'),
		// 	{
		// 		y: '20px',
		// 		ease: 'expo.out',
		// 		duration: 1.5,
		// 	},
		// 	'<'
		// );
		// this.tl.from(
		// 	this.mainHeader.querySelectorAll('.menu-item'),
		// 	{
		// 		y: '20px',
		// 		stagger: 0.15,
		// 		duration: 1,
		// 		ease: 'expo.out',
		// 	},
		// 	'-=1.5'
		// );
		// this.tl.from(
		// 	this.mainHeader.querySelectorAll('.header__icons button'),
		// 	{
		// 		y: '20px',
		// 		ease: 'expo.out',
		// 	},
		// 	'-=1.5'
		// );
	}
	_pinLogoV() {
		ScrollTrigger.create({
			trigger: this.logoV,
			pin: true,
			start: 'top 20px',
			scrub: 0.5,
			endTrigger: 'footer',
			end: 'top top',
			pinSpacing: false,
		});
		ScrollTrigger.create({
			trigger: '.site--hero',
			end: 'bottom-=25px',
			onLeave: () => {
				this.logoV.classList.add('active');
			},
			onEnterBack: () => {
				this.logoV.classList.remove('active');
			},
		});
	}
}
